import React, { useMemo } from "react";

import moment from "moment-timezone";

import { useCurrentServer } from "providers/WithCurrentOrganization";
import { WithRetention } from "providers/WithDateRange";
import { retention } from "utils/limits";

export default function WithServerRetention({
  children,
}: {
  children: React.ReactNode;
}) {
  const { retentionInDays } = useCurrentServer(true) || {
    retentionInDays: null,
  };
  const serverRetention = useMemo(() => {
    if (!retentionInDays) {
      return undefined;
    }
    return moment.duration(retentionInDays, "days");
  }, [retentionInDays]);

  return (
    <WithRetention retention={serverRetention ?? retention.default}>
      {children}
    </WithRetention>
  );
}
